import { repository, baseURL } from "@/api/base"

export default {
  async getCatalog() {
    const { data } = await repository.get(baseURL + '/dictionary/groupNumber/findAll')
    return data
  },

  async create(body) {
    const { data } = await repository.post(baseURL + '/dictionary/groupNumber', body)
    return data
  },

  async update(body) {
    const { data } = await repository.put(baseURL + '/dictionary/groupNumber', body)
    return data
  },

  async remove(id) {
    return await repository.delete(baseURL + '/dictionary/groupNumber/' + id)
  }
}